import React, { Component } from 'react';

import OviewMap from './Oview/OviewMap'
import { SearchParamProcess } from '../SearchParamProcess'
import { BottomStatusBar } from './BottomStatusBar/BottomStatusBar'
import { RightPanel } from './RightPanel/RightPanel'
import { LayersMap } from './.draggable/LayersMap/LayersMap'
import { MeasureTool } from './.draggable/MeasureTool/MeasureTool'
import { MarkFunction } from './.draggable/MarkFunction/MarkFunction'
import { PrintFunction } from './.draggable/PrintFunction/PrintFunction'
import { KMLUploadTool } from './.draggable/KMLUploadTool/KMLUploadTool';
import { ReadilyAvailableHouseTool } from './.draggable/ReadilyAvailableHouseTool/ReadilyAvailableHouseTool';
import { LocateTool } from './.draggable/LocateTool/LocateTool';
import { TravelDiaryTool } from './.draggable/TravelDiaryTool/TravelDiaryTool';
import { ThreeDBuildingTool } from './.draggable/ThreeDBuildingTool/ThreeDBuildingTool';
import { Socioeconomic } from './.draggable/Socioeconomic/Socioeconomic';
import { TopBar } from './TopBar/TopBar';
import { BottomBar } from './BottomBar/BottomBar'
import { MinimizedWindowStatusBar } from './MinimizedWindowStatusBar/MinimizedWindowStatusBar';
import { LayoutContext } from './../../modules/ContextModules/LayoutContext';
import { AttributesModal } from './AttributesModal/AttributesModal';
import { LayerAttrsRnd } from './LayerAttrsRnd/LayerAttrsRnd';

//Api
import ApiLayersMap from '../../modules/WebApiModules/ApiLayersMap';

//樣式
import './Layout.css'

//圖片
import logo1 from './.image/南投縣政府新logo.png'
//import logo2 from './.image/42531_5.png'

const townNames = ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"];

const buildingAttrMap = {
    "BUILD_ID": "建物編號", "BUILDNAME": "建物名稱", "BUILDTYPE": "建物類型",
    "BUILD_STR": "建物結構", "M_SOURCE": "建物模型產製單位", "SOURCE": "SOURCE", "SOURCE_DES": "SOURCE_DES",
    "MDATE": "建物框繪製年月", "BUILD_H": "建物高度", "BUILD_NO": "建物樓層數", "H_SOURCE": "H_SOURCE",
    "H_EXTRAC": "H_EXTRAC", "NO_SOURCE": "NO_SOURCE", "M_MDATE": "建物模型產製日期", "MODEL_LOD": "LOD細緻度等級代碼",
    "COUNTY": "直轄市、縣(市)名稱", "MODEL_NAME": "模型檔案名稱", "CENT_E_97": "建物框中心E座標", "CENT_N_97": "建物框中心N座標",
    "C_FRAMEID": "圖幅框ID"
};

export class Layout extends Component {
    // ref = React.createRef();

    constructor(props) {
        super(props);
        ////// 在 state 中放入修改 state 的方法，並傳入 <Context.Provider> 中
        this.state = {
            opacityValue:100,
            // 自己的屬性
            // width: 0,
            // height: 0,
            // 已選圖層 狀態
            selectedLayerContext: {
                layers: [],
                economicLayerModules: undefined,
                updateLayers: this.updateLayers,
                addInitLayer: this.addInitLayer,
            },
            // 視窗 狀態
            draggableWindowContext: {
                minimizedStatusStack: [],
                layersMap: {
                    name: "圖資庫",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "layersMap");
                    }
                },
                measureTool: {
                    name: "測量工具",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "measureTool");
                    }
                },
                markFunction: {
                    name: "標註功能",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "markFunction");
                    }
                },
                printFunction: {
                    name: "列印功能",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "printFunction");
                    }
                },
                kmlUploadTool: {
                    name: "道路養護",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "kmlUploadTool");
                    }
                },
                readilyAvailableHouseTool: {
                    name: "既有成屋",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "readilyAvailableHouseTool");
                    }
                },
                locateTool: {
                    name: "定位工具",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "locateTool");
                    }
                },
                travelDiaryTool: {
                    name: "旅圖日記",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "travelDiaryTool");
                    }
                },
                threeDBuildingTool: {
                    name: "介接功能",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "threeDBuildingTool");
                    }
                },
                socioeconomic: {
                    name: "經濟資料",
                    isOpened: false,
                    isMinimized: false,
                    update: (status) => {
                        this.updateDraggableWindow(status, "socioeconomic");
                    }
                },
            },
            //既有成屋狀態
            readilyAvailableHouseToolContext: {
                layer: undefined,
                selectedBuildingID: -1,
                setID: this.readilyAvailableHouseSetID,
                set: this.readilyAvailableHouseSetLayer,
                remove: this.readilyAvailableHouseRemoveLayer,
            },
            // KML 上傳狀態
            kmlUploadContext: {
                kmlList: [],
                push: this.pushKMLItem,
                updateList: this.updateKMLList,
                toggleOpened: this.toggleKMLOpened,
                copyByRef: this.copyByRefKMLInstance,
                updateContextList: this.updateKMLContextList,
            },
            // 屬性視窗 狀態
            attributesModalContext: {
                isOpened: false,
                position: { x: "10px", y: "-25px" },
                content: (<>asjfl;ka
                    <div>jsda;fkjs;</div>
                    <div>jsda;fkjs;</div>
                    <div>jsda;fkjs;</div>
                    <div>jsda;fkjs;</div>
                    <div>jsda;fkjs;</div></>),
                updateContent: this.updateAttributesContent,
            },
            // 近似化建物 介接狀態
            buildingToolContext: {
                buildingList: [],
                push: this.pushBuildingItem,
                remove: this.removeBuildingItem,
                setOpacity: this.setBuildingItemOpacity,
            },
            //經濟工具 狀態
            socioeconomicContext: {
                layerModule: undefined,
                data: [],
                labels: [],
                height: 200,
                selectTown: townNames,
                backgroundColorArray: [],
                borderColorArray: [],
                showChart: false,
                update: this.updateSocioeconomicContext,
                remove: this.removeSocioeconomicContext
            },
            travelDiaryToolContext: {
                token: "",
                update: this.updateTravelDiaryToolContext
            },
            LayerAttrsRndContext: {
                attrsMaps: [buildingAttrMap],
                layerAttrsRndTitle: "",
                isShowLayerAttrsRnd: false,
                layerAttrsRnd: {},
                layerAttrsRndPosition: { x: 0, y: 0 },
                update: this.updateLayerAttrsRnd,
            }
        }
    }

    addInitLayer(FolderFullName, Name) {
        ApiLayersMap.ListLayerInfo(
            { FolderFullName: FolderFullName, Name: Name },
            (obj) => {
                let result = obj.result;
                let addLayer = [];
                addLayer.push(result);
                this.updateLayers(
                    {
                        add: addLayer
                    });
            },
            () => {
                console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`)
            }
        )
    }

    ////// 定義修改 state 的方法
    /* 更新選取圖層狀態 */updateLayers = (updatingLayers) => {
        let updatedLayers = this.state.selectedLayerContext.layers;
        // remove
        if (updatingLayers.remove && updatingLayers.remove.length > 0) {
            updatedLayers = updatedLayers.filter((layer) => {
                return updatingLayers.remove.indexOf(layer.Name) < 0;
            })
        }
        // add
        if (updatingLayers.add && updatingLayers.add.length > 0) {
            updatedLayers = updatedLayers.concat(updatingLayers.add);
        }

        this.setState(prevState => ({
            // 加入圖層 
            selectedLayerContext: {
                ...prevState.selectedLayerContext,
                layers: updatedLayers
            },
        }))
    }

    /* 更新可拖曳視窗狀態 */updateDraggableWindow = (status, contextKey) => {
        let updatedMinimizedStatusStack = this.state.draggableWindowContext.minimizedStatusStack;
        let index = updatedMinimizedStatusStack.indexOf(contextKey);
        if (status.isOpened) { //開啟視窗
            if (index < 0) { //不存在就push                
                updatedMinimizedStatusStack.push(contextKey);
            }
        } else { //關閉視窗
            if (index >= 0) { //從清單移除               
                updatedMinimizedStatusStack.splice(index, 1);
            }
        }
        let newDraggableWindowContext = this.state.draggableWindowContext;
        newDraggableWindowContext.minimizedStatusStack = updatedMinimizedStatusStack;
        newDraggableWindowContext[contextKey] = {
            ...this.state.draggableWindowContext[contextKey],
            isOpened: status.isOpened,
            isMinimized: status.isMinimized,
        }
        this.setState({
            draggableWindowContext: newDraggableWindowContext
        })

    }

    /* 新增KML項目 */pushKMLItem = (kml) => {
        // 更新
        let newKMLUploadContext = this.state.kmlUploadContext;
        newKMLUploadContext.kmlList.push(kml);
        this.updateKMLContextList(newKMLUploadContext.kmlList);
    }

    /* 更新KML清單 */updateKMLList = (list) => {
        let oldList = this.state.kmlUploadContext.kmlList;
        let newList = list.map((name) => { return { name: name, isOpened: false } });
        for (let i in newList) {
            let newOne = newList[i];
            for (let j in oldList) {
                let oldOne = oldList[j];
                if (newOne.name === oldOne.name) {
                    newOne.isOpened = oldOne.isOpened;
                    newOne.instance = oldOne.instance;
                    break;
                }
            }
        }
        // 更新
        this.updateKMLContextList(newList);
    }
    /* 切換KML開關 */toggleKMLOpened = (name) => {
        let newList = this.state.kmlUploadContext.kmlList;
        for (let i in newList) {
            let kml = newList[i];
            if (kml.name === name) {
                kml.isOpened = !kml.isOpened;
                break;
            }
        }
        // 更新
        let newKMLUploadContext = this.state.kmlUploadContext;
        newKMLUploadContext.kmlList = newList;
        this.updateKMLContextList(newKMLUploadContext.kmlList);
    }

    /* 複製一份kml實體 */copyByRefKMLInstance = (name, instance) => {
        let newList = this.state.kmlUploadContext.kmlList;
        for (let i in newList) {
            let kml = newList[i];
            if (kml.name === name) {
                kml.instance = instance;
                break;
            }
        }
        // 更新
        this.updateKMLContextList(newList);
    }

    /* 更新kml context*/ updateKMLContextList = (newList) => {
        // 更新
        let newKMLUploadContext = this.state.kmlUploadContext;
        newKMLUploadContext.kmlList = newList;
        this.setState({
            kmlUploadContext: newKMLUploadContext
        });
    }

    /* 更新並開啟屬性視窗 */ updateAttributesContent = (param) => {
        // 更新
        let newAttributesModalContext = this.state.attributesModalContext;
        newAttributesModalContext.isOpened = param.isOpened !== false;
        newAttributesModalContext.position = param.position || newAttributesModalContext.position;
        newAttributesModalContext.content = param.content || newAttributesModalContext.content;
        this.setState({
            attributesModalContext: newAttributesModalContext
        });
    }
    ////

    /* 新增既有成屋圖層 */readilyAvailableHouseSetLayer = (layer) => {
        // 更新
        let readilyAvailableHouseToolContext = this.state.readilyAvailableHouseToolContext;
        readilyAvailableHouseToolContext.layer = layer
        this.setState({
            readilyAvailableHouseToolContext: readilyAvailableHouseToolContext
        });
    }

    /* 移除既有成屋圖層 */readilyAvailableHouseRemoveLayer = () => {
        let readilyAvailableHouseToolContext = this.state.readilyAvailableHouseToolContext;
        if (!!readilyAvailableHouseToolContext.layer) {
            window.gMainMap.TerrainView.removeLayer(readilyAvailableHouseToolContext.layer);
            readilyAvailableHouseToolContext.layer = undefined;
            readilyAvailableHouseToolContext.selectedBuildingID = -1;
        }
        this.setState({
            readilyAvailableHouseToolContext: readilyAvailableHouseToolContext
        });
    }

    /*設定點擊建物ID*/
    readilyAvailableHouseSetID = (id) => {
        let readilyAvailableHouseToolContext = this.state.readilyAvailableHouseToolContext;
        readilyAvailableHouseToolContext.selectedBuildingID = id;
        this.setState({
            readilyAvailableHouseToolContext: readilyAvailableHouseToolContext
        });
    }

    /* 新增近似化建物項目 */pushBuildingItem = (building) => {
        // 更新
        let newBuildingToolContext = this.state.buildingToolContext;
        newBuildingToolContext.buildingList.push(building);
        this.setState({
            buildingToolContext: newBuildingToolContext
        });
    }

     /* 移除近似化建物項目 */removeBuildingItem = (index) => {
        let newBuildingToolContext = this.state.buildingToolContext;
        let item = newBuildingToolContext.buildingList[index];

        window.gMainMap.TerrainView.removeLayer(item.layer);
        newBuildingToolContext.buildingList.splice(index, 1);
        this.setState({
            buildingToolContext: newBuildingToolContext
        });
    }

    /* 變更近似化建物項目透明度 */setBuildingItemOpacity = (index, value) => {
        // 更新
        let newBuildingToolContext = this.state.buildingToolContext;
        let item = newBuildingToolContext.buildingList[index];
        item.opacity = value;
        item.layer.setOpacity(value);
        this.setState({
            buildingToolContext: newBuildingToolContext
        });
    }

    /* 變更經濟工具資料 */updateSocioeconomicContext = (param) => {
        // 更新
        let newSocioeconomicContext = this.state.socioeconomicContext;

        if (param.isEmptyModule) {
            newSocioeconomicContext.layerModule = undefined;
        }
        else {
            newSocioeconomicContext.layerModule = param.layerModule || newSocioeconomicContext.layerModule;
        }
        newSocioeconomicContext.selectTown = param.selectTown || newSocioeconomicContext.selectTown;
        newSocioeconomicContext.showChart = param.showChart || newSocioeconomicContext.showChart;
        newSocioeconomicContext.labels = param.labels || newSocioeconomicContext.labels;
        newSocioeconomicContext.data = param.data || newSocioeconomicContext.data;
        newSocioeconomicContext.height = param.height || newSocioeconomicContext.height;
        newSocioeconomicContext.borderColorArray = param.borderColorArray || newSocioeconomicContext.borderColorArray;
        newSocioeconomicContext.backgroundColorArray = param.backgroundColorArray || newSocioeconomicContext.backgroundColorArray;
        this.setState({
            socioeconomicContext: newSocioeconomicContext
        });
    }

    /* 移除經濟工具資料 */removeSocioeconomicContext = () => {
        // 移除
        let newSocioeconomicContext = this.state.socioeconomicContext;

        newSocioeconomicContext.showChart = false;
        newSocioeconomicContext.selectTown = ["南投市", "埔里鎮", "草屯鎮", "竹山鎮", "集集鎮", "名間鄉", "鹿谷鄉", "中寮鄉", "魚池鄉", "國姓鄉", "水里鄉", "信義鄉", "仁愛鄉"];
        newSocioeconomicContext.labels = [];
        newSocioeconomicContext.data = [];
        newSocioeconomicContext.borderColorArray = [];
        newSocioeconomicContext.backgroundColorArray = [];
        newSocioeconomicContext.height = 200;
        this.setState({
            socioeconomicContext: newSocioeconomicContext
        });
    }

    /**變更旅行日記資料 */updateTravelDiaryToolContext = (param) => {
        // 更新
        let newTravelDiaryToolContext = this.state.travelDiaryToolContext;

        newTravelDiaryToolContext.token = param.token || newTravelDiaryToolContext.token;

        this.setState({
            travelDiaryToolContext: newTravelDiaryToolContext
        });
    }

    /**變更屬性視窗 */updateLayerAttrsRnd = (param) => {
        let newLayerAttrsRndContext = this.state.LayerAttrsRndContext;

        newLayerAttrsRndContext.layerModule = param.layerModule || newLayerAttrsRndContext.layerModule;
        newLayerAttrsRndContext.layerAttrsRndTitle = param.layerAttrsRndTitle || newLayerAttrsRndContext.layerAttrsRndTitle;
        newLayerAttrsRndContext.isShowLayerAttrsRnd = param.isShowLayerAttrsRnd !== undefined ? param.isShowLayerAttrsRnd : newLayerAttrsRndContext.isShowLayerAttrsRnd;
        newLayerAttrsRndContext.layerAttrsRnd = param.layerAttrsRnd || newLayerAttrsRndContext.layerAttrsRnd;
        newLayerAttrsRndContext.layerAttrsRndPosition = param.layerAttrsRndPosition || newLayerAttrsRndContext.layerAttrsRndPosition;
        this.setState({
            LayerAttrsRndContext: newLayerAttrsRndContext
        });
    }

    async Async_WaitMapInit() {
        if (window.gMainMap.IsReady) {
            return;
        }
        function Wait(time) {
            return new Promise((rs) => { setTimeout(rs, time ?? 100) })
        }
        while (!window.gMainMap.IsReady) {
            await Wait();
        }
    }

    componentDidMount() {
        this.Async_WaitMapInit().then(() => {
            this.addInitLayer("/底圖", "正射影像");
            this.addInitLayer("/三維圖資", "南投市近似化建物");

            this.mapClickResetEvent = () => {
                if (this.state.LayerAttrsRndContext.isShowLayerAttrsRnd === true) {
                    this.state.LayerAttrsRndContext.update({ isShowLayerAttrsRnd: false });
                }
            };

            let updateOpacity = () => {
                this.seeOpacity();
            };
            this.updateOpacityIntervalId = setInterval(updateOpacity, 1000);

            window.gMainMap.TerrainView.addEventListener("MouseDown", this.mapClickResetEvent.bind(this));
        });

        // const { current } = this.ref;
        // this.setState({
        //     width: current.offsetWidth,
        //     height: current.offsetHeight
        // })
    }

    render() {
        return (
            <LayoutContext.Provider value={this.state}>
                <SearchParamProcess />
                <div ref={this.ref} className='layout'>
                    <div className="layout__header noPrint">
                        <div className='logo__img' onClick={() => { window.gMainMap.Close(); this.props.changePage(1); }}>
                            <img className='logo' src={logo1} alt="圖台_標誌"></img>
                            {/*<img className='logo' src={logo2} alt="圖台_標誌2"></img>*/}
                            </div>
                        <div className='topBarContainer'>
                            <TopBar />
                        </div>
                    </div>
                    <div className="layout__body">
                        <OviewMap />
                        <RightPanel />
                        {   //圖資庫移動視窗
                            this.handleDraggableWindowDisplay("layersMap") ?
                                <LayersMap width={500} height={500} defaultPosition={{ x: 450, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("layersMap"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("layersMap"); }}
                                    isShow={!this.isDraggableWindowMinimize("layersMap")} />
                                : null
                        }
                        {   //測量工具移動視窗
                            this.handleDraggableWindowDisplay("measureTool") ?
                                <MeasureTool width={300} height={300} defaultPosition={{ x: 300, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("measureTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("measureTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("measureTool")} />
                                : null
                        }
                        {   //標註功能移動視窗
                            this.handleDraggableWindowDisplay("markFunction") ?
                                <MarkFunction width={450} height={450} defaultPosition={{ x: 300, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("markFunction"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("markFunction"); }}
                                    isShow={!this.isDraggableWindowMinimize("markFunction")} />
                                : null
                        }
                        {   //列印功能移動視窗
                            this.handleDraggableWindowDisplay("printFunction") ?
                                <PrintFunction width={200} height={200} defaultPosition={{ x: 100, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("printFunction"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("printFunction"); }}
                                    isShow={!this.isDraggableWindowMinimize("printFunction")} />
                                : null
                        }
                        {   //kml上傳功能移動視窗
                            this.handleDraggableWindowDisplay("kmlUploadTool") ?
                                <KMLUploadTool width={500} height={300} defaultPosition={{ x: 300, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("kmlUploadTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("kmlUploadTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("kmlUploadTool")} />
                                : null
                        }
                        {   //既有成屋功能移動視窗
                            this.handleDraggableWindowDisplay("readilyAvailableHouseTool") ?
                                <ReadilyAvailableHouseTool width={500} height={500} defaultPosition={{ x: 350, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("readilyAvailableHouseTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("readilyAvailableHouseTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("readilyAvailableHouseTool")} />
                                : null
                        }
                        {   //定位功能移動視窗
                            this.handleDraggableWindowDisplay("locateTool") ?
                                <LocateTool width={450} height={450} defaultPosition={{ x: 400, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("locateTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("locateTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("locateTool")} />
                                : null
                        }
                        {   //旅行日記功能移動視窗
                            this.handleDraggableWindowDisplay("travelDiaryTool") ?
                                <TravelDiaryTool width={400} height={450} defaultPosition={{ x: 400, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("travelDiaryTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("travelDiaryTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("travelDiaryTool")} />
                                : null
                        }
                        {   //介接3D模型功能移動視窗
                            this.handleDraggableWindowDisplay("threeDBuildingTool") ?
                                <ThreeDBuildingTool width={500} height={400} defaultPosition={{ x: 450, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("threeDBuildingTool"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("threeDBuildingTool"); }}
                                    isShow={!this.isDraggableWindowMinimize("threeDBuildingTool")} />
                                : null
                        }
                        {   //社會經濟資料功能移動視窗
                            this.handleDraggableWindowDisplay("socioeconomic") ?
                                <Socioeconomic width={700} height={this.state.socioeconomicContext.height} defaultPosition={{ x: 450, y: 100 }}
                                    handleMinimize={() => { this.handleDraggableWindowMinimize("socioeconomic"); }}
                                    handleCancel={() => { this.handleDraggableWindowCancel("socioeconomic"); }}
                                    isShow={!this.isDraggableWindowMinimize("socioeconomic")} />
                                : null
                        }
                        {
                            this.handleAttributesModalDisplay() ?
                                <AttributesModal content={this.handleAttributesModalContent()} position={this.handleAttributesModalPosition()} />
                                : null
                        }
                        <LayerAttrsRnd />
                        <div className="layout_opacity">
                            <input type="range" id="opacityInputTerrain" min="0" max="100" defaultValue="100" step="5"
                                onChange={(e) => this.opacityOnChange(e)}
                                style={{ backgroundSize: `${3 + this.state.opacityValue * 0.94}% 100%` }}></input>
                            <span style={{ color: this.state.opacityValue < 55 ? "white" : "" }}>不透明度:{this.state.opacityValue}%</span>
                        </div>
                        <div className='bottomBarContainer noPrint'>
                            <BottomBar />
                        </div>
                    </div>
                    <div className="layout__footer layout__footer--exclude-mobile noPrint">
                        <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex' }}>
                            <div className='minimizedWinodwStatusBarContainer'>
                                <MinimizedWindowStatusBar data={this.state.draggableWindowContext} />
                            </div>
                            <div className='bottomStatusBarContainer'>
                                <BottomStatusBar />
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutContext.Provider>
        );
    }

    opacityOnChange(e) {
        this.setState({ opacityValue: e.target.value });
        window.gMainMap.TerrainView.terrainAlpha = parseFloat(e.target.value) / 100.0;
    }

    seeOpacity() {
        let opacity = window.gMainMap.TerrainView.terrainAlpha;
        if (opacity * 100 !== this.state.opacityValue) {
            this.setState({ opacityValue: parseInt(opacity * 100) });
            let opacityInput = document.getElementById("opacityInputTerrain");
            opacityInput.value = opacity * 100;
        }
    }

    handleDraggableWindowDisplay = (key) => {
        let state = this.state.draggableWindowContext[key];
        return state.isOpened;
    }

    isDraggableWindowMinimize = (key) => {
        let state = this.state.draggableWindowContext[key];
        return state.isMinimized;
    }

    handleDraggableWindowMinimize = (key) => {
        this.state
            .draggableWindowContext[key]
            .update({
                isOpened: true,
                isMinimized: true
            });
    }

    handleDraggableWindowCancel = (key) => {
        console.log("關閉");
        this.state
            .draggableWindowContext[key]
            .update({
                isOpened: false,
            });
    }

    handleAttributesModalDisplay = () => {
        return this.state
            .attributesModalContext
            .isOpened;
    }

    handleAttributesModalContent = () => {
        return this.state
            .attributesModalContext
            .content;
    }

    handleAttributesModalPosition = () => {
        return this.state
            .attributesModalContext
            .position;
    }
}